(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-gallery-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('galleryModal');
    const modalImage = document.getElementById('galleryModalImage');
    const modalTitle = document.getElementById('galleryModalTitle');
    const modalDescription = document.getElementById('galleryModalDescription');
    const thumbnailsContainer = document.getElementById('galleryThumbnails');
    const counter = document.getElementById('galleryCounter');
    const closeBtn = document.getElementById('galleryModalClose');
    const prevBtn = document.getElementById('galleryPrev');
    const nextBtn = document.getElementById('galleryNext');
    const triggers = document.querySelectorAll('[data-modal-trigger]');

    let currentImages = [];
    let currentIndex = 0;
    let isModalOpen = false;
    let currentTitle = '';
    let currentDescription = '';

    // Function to render thumbnails
    function renderThumbnails(images, currentIdx) {
      thumbnailsContainer.innerHTML = '';

      if (!images || images.length === 0) {
        return;
      }

      images.forEach(function(img, index) {
        const thumb = document.createElement('div');
        thumb.className = 'gallery-modal__thumbnail';
        if (index === currentIdx) {
          thumb.classList.add('active');
        }

        const imgElement = document.createElement('img');
        imgElement.src = img;
        imgElement.alt = 'Thumbnail ' + (index + 1);
        imgElement.loading = 'lazy';

        thumb.appendChild(imgElement);
        thumb.addEventListener('click', function() {
          currentIndex = index;
          updateMainImage(images[index]);
          updateThumbnailsActive(index);
          updateCounter(index, images.length);
          updateNavButtons(index, images.length);
        });

        thumbnailsContainer.appendChild(thumb);
      });
    }

    // Function to update main image
    function updateMainImage(src) {
      modalImage.innerHTML = `<img src="${src}" alt="${currentTitle || 'Image'}" loading="lazy">`;
      // Re-add navigation buttons and counter
      const mainWrapper = modalImage;
      mainWrapper.appendChild(prevBtn);
      mainWrapper.appendChild(nextBtn);
      mainWrapper.appendChild(counter);
    }

    // Function to update thumbnails active state
    function updateThumbnailsActive(index) {
      const thumbs = thumbnailsContainer.querySelectorAll('.gallery-modal__thumbnail');
      thumbs.forEach(function(thumb, i) {
        thumb.classList.toggle('active', i === index);
      });
    }

    // Function to update counter
    function updateCounter(index, total) {
      if (total > 1) {
        counter.textContent = (index + 1) + ' / ' + total;
        counter.style.display = 'block';
      } else {
        counter.style.display = 'none';
      }
    }

    // Function to update navigation buttons
    function updateNavButtons(index, total) {
      if (total <= 1) {
        prevBtn.classList.add('gallery-modal__nav-arrow--hidden');
        nextBtn.classList.add('gallery-modal__nav-arrow--hidden');
        return;
      }

      prevBtn.classList.toggle('gallery-modal__nav-arrow--hidden', index === 0);
      nextBtn.classList.toggle('gallery-modal__nav-arrow--hidden', index === total - 1);
    }

    // Navigate to previous image
    function goToPrev() {
      if (currentIndex > 0) {
        currentIndex--;
        updateMainImage(currentImages[currentIndex]);
        updateThumbnailsActive(currentIndex);
        updateCounter(currentIndex, currentImages.length);
        updateNavButtons(currentIndex, currentImages.length);
      }
    }

    // Navigate to next image
    function goToNext() {
      if (currentIndex < currentImages.length - 1) {
        currentIndex++;
        updateMainImage(currentImages[currentIndex]);
        updateThumbnailsActive(currentIndex);
        updateCounter(currentIndex, currentImages.length);
        updateNavButtons(currentIndex, currentImages.length);
      }
    }

    // Function to open modal
    function openModal(title, description, images) {
      currentImages = images || [];
      currentTitle = title || '';
      currentDescription = description || '';
      currentIndex = 0;

      // Set title - only if it exists
      if (title && title.trim() !== '') {
        modalTitle.textContent = title;
        modalTitle.style.display = 'block';
      } else {
        modalTitle.style.display = 'none';
      }

      // Set description - only if it exists
      if (description && description.trim() !== '') {
        modalDescription.innerHTML = description;
        modalDescription.style.display = 'block';
      } else {
        modalDescription.style.display = 'none';
      }

      // Set images
      if (currentImages && currentImages.length > 0) {
        updateMainImage(currentImages[0]);
        renderThumbnails(currentImages, 0);
        updateCounter(0, currentImages.length);
        updateNavButtons(0, currentImages.length);
      } else {
        modalImage.innerHTML = `
          <div class="placeholder">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <rect x="3" y="3" width="18" height="18" rx="2"/>
              <circle cx="8.5" cy="8.5" r="1.5"/>
              <path d="M21 15L16 10L5 21"/>
            </svg>
          </div>
        `;
        thumbnailsContainer.innerHTML = '';
        counter.style.display = 'none';
        prevBtn.classList.add('gallery-modal__nav-arrow--hidden');
        nextBtn.classList.add('gallery-modal__nav-arrow--hidden');
      }

      // Show modal with animation
      modal.classList.add('active');
      document.body.classList.add('modal-open');
      isModalOpen = true;

      // Focus the modal
      modal.focus();
    }

    // Function to close modal
    function closeModal() {
      modal.classList.remove('active');
      document.body.classList.remove('modal-open');
      isModalOpen = false;
    }

    // Click triggers
    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(e) {
        // Don't open modal if clicking on a link inside the block
        if (e.target.closest('a')) {
          return;
        }

        const title = this.dataset.title || '';
        const description = this.dataset.description || '';
        const imagesData = this.dataset.images || '[]';
        let images = [];

        try {
          images = JSON.parse(imagesData);
        } catch (e) {
          images = [];
        }

        const hasTitle = this.dataset.hasTitle === 'true';
        const hasDescription = this.dataset.hasDescription === 'true';

        // Only pass data if it exists
        const finalTitle = hasTitle ? title : '';
        const finalDescription = hasDescription ? description : '';

        openModal(finalTitle, finalDescription, images);
      });
    });

    // Close button
    closeBtn.addEventListener('click', closeModal);

    // Navigation buttons
    prevBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      goToPrev();
    });

    nextBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      goToNext();
    });

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (!isModalOpen) return;

      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        goToPrev();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        goToNext();
      }
    });

    // Click outside modal content to close
    modal.addEventListener('click', function(e) {
      if (e.target === this) {
        closeModal();
      }
    });

    // Prevent body scroll when modal is open
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Tab' && isModalOpen) {
        // Trap focus inside modal
        const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstFocusable = focusable[0];
        const lastFocusable = focusable[focusable.length - 1];

        if (e.shiftKey && document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        } else if (!e.shiftKey && document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    });

    // Handle images that fail to load
    modalImage.addEventListener('error', function(e) {
      if (e.target.tagName === 'IMG') {
        e.target.style.display = 'none';
        const placeholder = document.createElement('div');
        placeholder.className = 'placeholder';
        placeholder.innerHTML = `
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <rect x="3" y="3" width="18" height="18" rx="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <path d="M21 15L16 10L5 21"/>
          </svg>
        `;
        e.target.parentNode.appendChild(placeholder);
      }
    }, true);

    // Touch/swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;

    modalImage.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    modalImage.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) { // Minimum swipe distance
        if (diff > 0) {
          goToNext();
        } else {
          goToPrev();
        }
      }
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();
})();
